import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Text } from '@dotcom/crown-ui';
import HallmarkPlus from '../../../assets/hallmark-plus.svg';

export const useHplusContents = () => {
  const { t } = useTranslation();

  const secondContainerText = <Text as="span">{t('noCrNoHDialog.secondContainerText')}</Text>;

  const learnMoreButton = (
    <Button
      variant="secondary"
      onClick={() => window.location.replace('/hallmarkplus-account/')}
      testId="learn-more-dialog-button"
    >
      {t('noCrNoHDialog.secondContainerButtonText')}
    </Button>
  );

  const hPlusContainerContent = {
    image: HallmarkPlus,
    body: secondContainerText,
    btnAction: learnMoreButton,
  };

  return { hPlusContainerContent };
};
